module.exports = __webpack_public_path__ + "static/media/chevron-down-black.2bbfa08f.svg";